import api from './index';

/**
 * Get all chats for the current user
 * @returns {Promise<Array>} - List of chats
 */
export const getChats = async () => {
  const response = await api.get('/chats');
  return response.data;
};

/**
 * Create a new chat
 * @param {Object} chatData - Chat data
 * @param {string} chatData.name - Chat name (optional)
 * @returns {Promise<Object>} - Created chat data
 */
export const createChat = async (chatData = {}) => {
  // Generiere einen generischen Namen, wenn keiner angegeben ist
  if (!chatData.name) {
    const now = new Date();
    chatData.name = `Analyse vom ${now.getDate()}.${now.getMonth() + 1}`;
  }
  const response = await api.post('/chats', chatData);
  return response.data;
};

/**
 * Get messages for a specific chat
 * @param {number|string} chatId - Chat ID
 * @returns {Promise<Array>} - List of messages
 */
export const getChatMessages = async (chatId) => {
  const response = await api.get(`/chats/${chatId}/messages`);
  return response.data;
};

/**
 * Add a message to a chat
 * @param {number|string} chatId - Chat ID
 * @param {Object} messageData - Message data
 * @param {string} messageData.role - Message role (user or assistant)
 * @param {string} messageData.content - Message content
 * @returns {Promise<Object>} - Created message data
 */
export const addChatMessage = async (chatId, messageData) => {
  const response = await api.post(`/chats/${chatId}/messages`, messageData);
  return response.data;
};

/**
 * Save an analysis result to a chat
 * @param {number|string} chatId - Chat ID
 * @param {Object} data - Analysis data
 * @param {string} data.topic - Analysis topic
 * @param {Object} data.analysis - Analysis results
 * @param {string} data.modelUsed - Model used for analysis
 * @returns {Promise<Object>} - Response data
 */
export const saveAnalysis = async (chatId, data) => {
  // Speichere die Analyse
  const response = await api.post(`/chats/${chatId}/saveAnalysis`, data);
 
  // Aktualisiere den Chat-Namen mit dem Thema aus der Analyse oder fallback auf topic
  const chatName = data.analysis?.Thema || data.topic;
  await api.patch(`/chats/${chatId}`, {
    name: chatName
  });
 
  return response.data;
};
/**
 * Archive a specific chat
 * @param {number|string} chatId - Chat ID to archive
 * @returns {Promise<Object>} - Response data
 */
export const archiveChat = async (chatId) => {
  const response = await api.post(`/chats/${chatId}/archive`);
  return response.data;
};